{
  "questionnaire": {
    "welcomeIntro": "Help us get you set up by answering a few quick questions",
    "step": "Step",
    "steps": "Step {{ currentStep }} of {{ totalSteps }}",
    "reason": {
      "question": "Tell us what brought you to Iventis today?",
      "options": {
        "SitePlanForMyEvent": "To create a site plan for my event",
        "TeamPlanMoreEfficiently": "See how my team can plan more efficiently",
        "PlanMultipleEventsPerProject": "Explore how to plan multiple events or projects",
        "JustCurious": "Just curious"
      }
    },
    "eventType": {
      "question": "And what are you looking to plan?",
      "options": {
        "SportsEvent": "Sports event",
        "RoadEvent": "Road event",
        "FestivalOrParade": "Festival or parade",
        "ExhibitionOrShow": "Exhibitions & conferences",
        "MajorEvent": "Major event",
        "MultipleEvents": "Multiple events",
        "Venue": "A venue",
        "SomethingElse": "Something else"
      }
    },
    "experience": {
      "question": "How much experience do you have with planning tools?",
      "options": {
        "HaventUsedBefore": "I haven't used any before",
        "Powerpoint": "Used PowerPoint",
        "GoogleEarth": "Used apps like Google Earth",
        "GisAndCadSoftware": "Used GIS and CAD software",
        "Iventis": "I have used Iventis before"
      }
    },
    "projectName": {
      "question": "And finally, what name do you have in mind for your project today?",
      "subLabel": "Hint: this could be your event or company name.",
      "options": {
        "projectName": "Project name"
      },
      "label": "Please enter a name for your project:"
    },
    "skip": "Skip for now",
    "ending_screen": {
      "initial_loading": {
        "message": "We are just setting things up for you",
        "subtext": "Setting up your project and analysing your requirements",
        "footerText": "This may take a few seconds"
      },
      "taking_longer": {
        "message": "It is taking a little longer than we expected, hang tight!",
        "subtext": "Sharpening up our tools to give you the crispest results",
        "footerText": "This may take a few seconds"
      },
      "error": {
        "message": "Ooops something has gone wrong.",
        "subtext": "There seems to be an issue on our side.",
        "footer_1": "Please",
        "footer_2": "so we can help you figure out what’s happened."
      }
    },
    "setup_completed": "Setup completed"
  },
  "passwordConditions": {
    "commonPassword": "Password too simple. Please try something more complex."
  },
  "verification": {
    "headings": {
      "checkEmail": "Check your email",
      "emailVerified": "Email verified",
      "alreadyVerified": "You're good to go"
    },
    "ctas": {
      "continueToLogin": "Continue to login",
      "resendEmail": "Click to resend"
    },
    "noEmail": "Didn't receive the email?",
    "emailSent": "We sent a verification link to",
    "timerForResend": "in {{ time }} seconds",
    "accountVerifiedMessage": "Your email account has been verified, click the button below to login.",
    "unverifiedErrorMessage": "We have been unable to verify your email account please contact our support team on",
    "alreadyVerifiedMessage": "This email account has already been verified. Click the button below to login."
  },
  "createAccount": {
    "free_trial": "Start Free Trial",
    "marketing": "Keep me up-to-date with the latest news and updates",
    "iventisAccount": "Already have an Iventis account?",
    "error": "There has been an issue creating your account. Please contact",
    "disableAdBlocker": "or try disabling your ad-blocker and try again."
  },
  "logout": "Logout"
}